import { CoeOfferDetailEntity } from '@genial/services';

export const normalizeBillingTypeOptions = (data?: CoeOfferDetailEntity) => {
  const defaultLabel = 'Default';

  return (
    data?.allowedBillingType?.map(({ billingDescription, billingTypeId }) => ({
      label: billingDescription?.trim() || defaultLabel,
      value: billingTypeId?.toString(),
    })) || []
  );
};
